var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentsEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "408px",
    height: "512px",
    viewBox: "0 0 408 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Art",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Source",
    transform: "translate(-9850.000000, -123.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "documents-empty-source",
    transform: "translate(9850.000000, 123.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,2 C8.2680135,2 2,8.2680135 2,16 L2,496 C2,503.731986 8.2680135,510 16,510 L391.44026,510 C399.172246,510 405.44026,503.731986 405.44026,496 L405.44026,16 C405.44026,8.2680135 399.172246,2 391.44026,2 L16,2 Z",
    stroke: "#D8D8D8",
    strokeWidth: 4,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    fill: "#D8D8D8",
    x: 42,
    y: 233,
    width: 324,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    fill: "#D8D8D8",
    x: 42,
    y: 316,
    width: 324,
    height: 43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,399 L366,399 L366,426 C366,434.836556 358.836556,442 350,442 L58,442 C49.163444,442 42,434.836556 42,426 L42,399 Z",
    id: "Rectangle-3-Copy-2",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.95926,90 C231.831405,118.681509 241.519127,137.974417 233.022428,147.878724 C224.525729,157.783032 214.851586,155.668361 204,141.534713 C192.941893,155.358696 183.24059,157.473366 174.896093,147.878724 C166.551595,138.284082 176.239318,118.991174 203.95926,90 Z",
    id: "Triangle",
    fill: "#D8D8D8",
    transform: "translate(204.000000, 122.000000) scale(1, -1) translate(-204.000000, -122.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,191 L364,191 L364,67 C364,59.2680135 357.731986,53 350,53 L58,53 C50.2680135,53 44,59.2680135 44,67 L44,191 Z",
    id: "Rectangle-2",
    stroke: "#D8D8D8",
    strokeWidth: 4
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsEmpty);
export default __webpack_public_path__ + "static/media/documents-empty.3ba9f2fa6218beab6b1e72e2ce12452b.svg";
export { ForwardRef as ReactComponent };